import React from 'react';
import shop from "shop/shop";
import { Button, Label, Modal, Pagination, Table } from "semantic-ui-react";

class CSVDownloader extends React.Component {
  
  tblName = shop.session.handUser.extras.selections;
  baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)

  render() {
    return (
        <a href={ `${this.baseUrl}/shop/rest/tables/export/${this.tblName}/1?name=${translate('Sortimente')}OWA.csv` } download={ `${translate('Sortimente')}OWA.csv` }><Button size={"tiny"} basic >{translate("CSV herunterladen")}</Button></a>
    );
  }
}

export default CSVDownloader;


// WEBPACK FOOTER //
// ./src/components/Budget/CSVDownloader.js